export const Work = [
  {
    id: 1,
    name: "Taxi Animation",
    description: "A simple moving car animation using simple css",
    tags: ["html", "css"],

    demo: "garvit1809.github.io/Taxi-Animation/",
    github: "github.com/Garvit1809/Taxi-Animation/tree/master",
  },
  {
    id: 2,
    name: "Samurai_battle",
    description: "A Javascript fighting game made using Html-Canvas",
    tags: ["html canvas", "css", "javascript"],

    demo: "garvit1809.github.io/Samurai-Battle/",
    github: "github.com/Garvit1809/Samurai-Battle",
  },
  {
    id: 3,
    name: "Stresser",
    description: `Stresser stresses on reducing peoples's stress and anxiety by providing therapy, diet, diary and chat features`,
    tags: ["react", "javascript", "node.js", "express", "mongodb", "mongoose"],
    demo: "github.com/Garvit1809/Stresser",
    github: "github.com/Garvit1809/Stresser",
  },
  {
    id: 4,
    name: "Wibezz",
    description: `A fashion agency's landing page with smooth animations`,
    tags: [
      "react",
      "gsap",
      "framer-motion",
      "locomotive-scroll",
      "styled-components",
    ],
    demo: "transcendent-tulumba-5617f9.netlify.app/",
    github: "github.com/Garvit1809/Wibe",
  },
  {
    id: 5,
    name: "Weirdoes",
    description:
      "A NFT collector UI application built using React, styled components, gsap, react-use, reat-confetti etc.",
    tags: ["react", "styled-components", "gsap", "react-confetti"],
    demo: "prismatic-naiad-f1dac2.netlify.app",
    github: "github.com/Garvit1809/Weirdoes",
  },
  {
    id: 6,
    name: "Menlo",
    description: `Built the frontend of our MVP `,
    tags: ["react", "javascript", "node.js", "express", "mongodb", "mongoose"],
    demo: "cool-froyo-53e4c9.netlify.app/",
    github: "cool-froyo-53e4c9.netlify.app/",
  },
  {
    id: 7,
    name: "WorkedIn",
    description:
      "An application through which you can collab with folks with good work ethics",
    tags: ["react", "typescript", "node.js", "express", "mongodb", "mongoose"],
    demo: "github.com/Garvit1809/WorkedIn",
    github: "github.com/Garvit1809/WorkedIn",
  },
  {
    id: 8,
    name: "Gumroad",
    description:
      "A fun project built in 4 days after getting exhausted from exams",
    tags: ["react", "javascript", "styled-components"],
    demo: "garvits-gumroad.netlify.app",
    github: "github.com/Garvit1809/Gumroad",
  },
  {
    id: 9,
    name: "Teach And Learn",
    description:
      "An ed-tech platform where students can teach and learn from each other.",
    tags: ["react", "typescript", "node.js", "express", "mongodb", "mongoose"],
    demo: "teachandlearn.app/",
    github: "github.com/Garvit1809/teachnlearn",
  },
];
